import {casaApiUrl} from '../configs/casa-api'
import {fetch} from '../utils/fetch'

export function getFileImportConfigs() {
  return fetch(`${casaApiUrl}/users/tenant/file_import_config`, {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Content-type': 'application/json'
    }
  }).then(r => r.json())
}

export function uploadOffers(data, storeId, tenantImportConfigId, tenantBrandBusinessId) {
  const uri = `${casaApiUrl}/users/data/upload/${storeId}/${tenantImportConfigId}/${tenantBrandBusinessId || ''}`
  return fetch(
    uri,
    {
      credentials: 'include',
      method: 'POST',
      body: data
    }
  ).then(r => r.json())
}

export function getPwaUrl(tenantId, businessUnitId, offerName) {
  const uri = `${casaApiUrl}/direct-offer/getShortenedOfferProgramUrl`
  return fetch(
    uri,
    {
      method: 'POST',
      body: JSON.stringify({
        tenant: tenantId,
        businessUnitId: businessUnitId,
        offerType: offerName
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }
  ).then(r => r.json())
}

export default {
  getFileImportConfigs,
  uploadOffers,
  getPwaUrl
}



// WEBPACK FOOTER //
// ./src/services/offer-config-service.js